import type { Response } from 'express';

import { BaseErrorBody } from '@r1-frontend/do-request/error';
import { redirectToChangeAgreementPage } from '@r1-frontend/entities/stores/auth/helpers/redirectToChangeAgreementPage';

export function catch401(error: BaseErrorBody, response?: Response): boolean {
    if (error.status === 401) {
        redirectToChangeAgreementPage(response);
        return true;
    }

    return false;
}
